import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useAdminStore } from './adminStore';

import AdminLogin    from './AdminLogin';
import AdminLayout   from './AdminLayout';
import Dashboard     from './pages/Dashboard';
import AdminStore    from './pages/AdminStore';
import AdminProducts from './pages/AdminProducts';
import AdminCategories from './pages/AdminCategories';
import AdminOrders       from './pages/AdminOrders';
import AdminOrderCreate  from './pages/AdminOrderCreate';
import AdminOrderDetail  from './pages/AdminOrderDetail';
import AdminBookOrders   from './pages/AdminBookOrders';
import AdminUsers       from './pages/AdminUsers';
import AdminCourier     from './pages/AdminCourier';
import AdminSettings    from './pages/AdminSettings';
import AdminReviews     from './pages/AdminReviews';
import AdminPromotions, { AdminMostSelling } from './pages/AdminPromotions';
import AdminNewArrivals from './pages/AdminNewArrivals';

function ProtectedRoute({ children }) {
  const { token } = useAdminStore();
  return token ? children : <Navigate to="/login" replace />;
}

function App() {
  const { token } = useAdminStore();

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={!token ? <AdminLogin /> : <Navigate to="/" replace />} />

        <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
          <Route path="/"            element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard"   element={<Dashboard />} />
          <Route path="/store"       element={<AdminStore />} />
          <Route path="/products"    element={<AdminProducts />} />
          <Route path="/categories"  element={<AdminCategories />} />
          <Route path="/orders"       element={<AdminOrders />} />
          <Route path="/orders/new"  element={<AdminOrderCreate />} />
          <Route path="/orders/book" element={<AdminBookOrders />} />
          <Route path="/orders/:id"  element={<AdminOrderDetail />} />
          <Route path="/courier"     element={<AdminCourier />} />
          <Route path="/settings"    element={<AdminSettings />} />
          <Route path="/reviews"      element={<AdminReviews />} />
          <Route path="/users"        element={<AdminUsers />} />
          <Route path="/promotions"    element={<AdminPromotions />} />
          <Route path="/most-selling"  element={<AdminMostSelling />} />
          <Route path="/new-arrivals"  element={<AdminNewArrivals />} />
        </Route>

        <Route path="*" element={<Navigate to={token ? '/dashboard' : '/login'} replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
